import { css } from "@emotion/react";

export const logoStyle = css`
  height: 100%;
  display: block;
  margin-right: auto;
  margin-left: auto;
`;

export const headerStyle = css`
  background: #ffffff;
`;

export const contentStyle = css`
  background: #ffffff;
`;

export const footerStyle = css`
  background: #ffffff;
  text-align: center;
  padding-left: 0px;
  padding-right: 0px;
  padding-bottom: 0px;
  padding-top: 40px;
`;
